//Jumbotron
//riceve: titolo, lead, BgImage

import React from "react";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";

import Typography from "@material-ui/core/Typography";

import useStyleJumbotron from "../styles/useStyleJumbotron";

const Jumbotron = (props) => {
  //in questo modo dico che tra gli stili utilzzero una variabile che mi arriva dai props
  const classes = useStyleJumbotron(props);
  return (
    <>
      <Box className={`${classes.jumbotronI} ${classes.jumbotron}`}>
        <Container maxWidth="lg">
          <Box>
            <Typography variant="h1" className={classes.jumboheader}>
              {props.titolo}
            </Typography>
            <Typography className={classes.lead}>{props.lead}</Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Jumbotron;
